import * as React from "react"
import Index from "../components/layout"
import Seo from "../components/seo"
import notFound from "@/assets/images/not-found.png"
import t from "@/constants/wording"

const NotFoundPage = () => {
  return (
    <Index>
      <Seo
        title={t("Not Found")}
        description={t("Not Found")}
        keywords={t("keywords")}
      />
      <div className="not-found-header"></div>
      <div className="not-found-content">
        <img alt="Not Found" src={notFound} />
        <div>Not Found</div>
        <h5>抱歉，你访问的页面不存在</h5>
      </div>
    </Index>
  )
}

export default NotFoundPage
